/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Usettings_Reset_HintsInputs */



/**
* | output |
* | --- |
* | "Reset hidden hints" |
*
* @param {Uno_Usettings_Reset_HintsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_usettings_reset_hints = /** @type {((inputs?: Uno_Usettings_Reset_HintsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Usettings_Reset_HintsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ausgeblendete Hinweise zurücksetzen")
	return /** @type {LocalizedString} */ ("Reset hidden hints")
});